import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { pushSupported, getPushSubscription, subscribePush, unsubscribePush } from "@/lib/pwa";
import { Button } from "@/components/ui/button";
import { Bell, BellRing, Loader2 } from "lucide-react";
import { toast } from "sonner";

export const PushToggle = () => {
  const [state, setState] = useState("loading"); // loading | off | on | unsupported
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (!pushSupported()) return setState("unsupported");
    getPushSubscription().then((s) => setState(s ? "on" : "off")).catch(() => setState("off"));
  }, []);

  if (state === "unsupported" || state === "loading") return null;

  const toggle = async () => {
    setBusy(true);
    try {
      if (state === "on") {
        await unsubscribePush(api);
        setState("off");
        toast.success("Quote alerts turned off");
      } else {
        await subscribePush(api);
        setState("on");
        toast.success("You'll get a push alert when a contractor sends a quote");
      }
    } catch (e) {
      toast.error(e.message === "denied" ? "Notifications are blocked in your browser settings." : "Could not update notifications.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <Button onClick={toggle} disabled={busy} variant="outline" size="sm" data-testid="push-toggle-btn"
      className={`h-7 rounded-sm border-border font-mono2 text-[10px] uppercase tracking-widest ${state === "on" ? "border-primary/60 text-primary" : ""}`}>
      {busy ? <Loader2 className="mr-1 h-3 w-3 animate-spin" /> : state === "on" ? <BellRing className="mr-1 h-3 w-3" /> : <Bell className="mr-1 h-3 w-3" />}
      {state === "on" ? "Alerts on" : "Quote alerts"}
    </Button>
  );
};
